import i18n from 'i18next'
import detector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import translationEN from '@/locales/en/translation.json'
import translationKO from '@/locales/ko/translation.json'
import translationJA from '@/locales/ja/translation.json'
import translationCN from '@/locales/cn/translation.json'

const resources = {
    en: {
        translation: translationEN
    },
    ko: {
        translation: translationKO
    },
    ja: {
        translation: translationJA
    },
    cn: {
        translation: translationCN
    }
}

i18n
    .use(detector)
    .use(initReactI18next)
    .init({
        resources,
        detection: { order: ['localStorage', 'navigator'] },
        fallbackLng: 'en',
        returnEmptyString: false,
        interpolation: {
            escapeValue: false
        }
    })

const updateDocumentLanguage = (language: string) => {
    document.documentElement.lang = language === 'cn' ? 'zh-CN' : language
}

updateDocumentLanguage(i18n.resolvedLanguage || i18n.language || 'ko')
i18n.on('languageChanged', updateDocumentLanguage)

export default i18n
